import React from "react";
import type { LegalDoc } from "./LegalPages";

// ============================================================
// ERUE FESTIVAL SUITE — LEGAL FOOTER (DROP 52C)
// Renders on all public pages
// ============================================================

interface LegalFooterProps {
  onOpenLegal: (doc: LegalDoc) => void;
}

const YEAR = new Date().getFullYear();

const LegalFooter: React.FC<LegalFooterProps> = ({ onOpenLegal }) => {
  const links: { label: string; doc: LegalDoc }[] = [
    { label: "Terms & Conditions", doc: "terms"      },
    { label: "Privacy Policy",     doc: "privacy"    },
    { label: "EULA",               doc: "eula"       },
    { label: "Cookie Policy",      doc: "cookies"    },
    { label: "Refund Policy",      doc: "refund"     },
    { label: "Disclaimer",         doc: "disclaimer" },
  ];

  return (
    <footer style={{
      background: "#070D0A",
      borderTop: "1px solid #1C2E22",
      padding: "24px 32px",
      marginTop: "auto",
    }}>
      {/* Festival Info */}
      <div style={{ textAlign: "center", marginBottom: 16 }}>
        <p style={{
          fontFamily: "'Cinzel', serif",
          color: "#C9A84C",
          fontSize: 13,
          margin: "0 0 4px",
          letterSpacing: 1,
        }}>
          ERUE Festival of Uzairue Kingdom
        </p>
        <p style={{ color: "#6B7280", fontSize: 11, margin: "0 0 4px" }}>
          December 24–30, 2026 &bull; Palace of the Ogieneni, Jattu-Uzairue
        </p>
        <p style={{
          color: "#4B5563",
          fontSize: 11,
          fontStyle: "italic",
          margin: 0,
        }}>
          &ldquo;One People, One Kingdom, One Destiny&rdquo;
        </p>
      </div>

      {/* Legal Links */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "8px 16px",
        marginBottom: 16,
      }}>
        {links.map(({ label, doc }) => (
          <button
            key={doc}
            onClick={() => onOpenLegal(doc)}
            style={{
              background: "none",
              border: "none",
              color: "#6B7280",
              cursor: "pointer",
              fontSize: 11,
              padding: "2px 0",
              textDecoration: "underline",
              textDecorationColor: "#1C2E22",
            }}
            onMouseEnter={e => (e.currentTarget.style.color = "#C9A84C")}
            onMouseLeave={e => (e.currentTarget.style.color = "#6B7280")}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Copyright */}
      <div style={{ textAlign: "center" }}>
        <p style={{ color: "#374151", fontSize: 11, margin: "0 0 2px" }}>
          &copy; {YEAR} Digitrax Finteca Consulting &mdash; digitraxfinteca.com
        </p>
        <p style={{ color: "#374151", fontSize: 10, margin: 0 }}>
          Platform v23.0 &bull; ERUE Festival Suite &bull; All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default LegalFooter;
